import React, { Fragment } from 'react';
import Head from 'next/head';
import dynamic from "next/dynamic";
import BannerWithGraphic from '../../components/common/BannerWithGraphic';
import styles from '../../styles/modules/common/banner-graphic.module.scss';
import CategoryListCard from '../../components/commom-pages/CategoryListCard'
import { GetInstaRepair } from '../../api/common-pages/index';
import { useRouter } from 'next/router';
import featuresStyles from "../../styles/modules/common/features.module.scss";
import { isMobile } from "react-device-detect";
import {trackPage} from "../../tracking/index";
import Config from '../../config';
import {getStaticPath} from '../../utils';
import { getPageViewData } from '../../utils/tracking';
import page_data from '../../data/page_data';

const LazyLoader = dynamic(()=> import("@/hoc/LazyLoader"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);

const Blog = dynamic(()=> import("../../components/common/Blog"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const Faq = dynamic(()=> import("../../components/common/Faq"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const CrossSell = dynamic(()=> import("../../components/cross-sell/CrossSell"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const FeatureImageBanner = dynamic(()=> import("../../components/common/FeatureImageBanner"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

const Testimonial = dynamic(()=> import("../../components/common/Testimonials"),
  {loading: () => <p>Loading ...</p>,ssr:true }
);

interface Props {
    products: any[],
    features: { [key: string]: any },
    faqs: any[],
    testimonials: any[],
    blogs: any[],
    bannerImageData: any,
    cross_sell: any[],
    meta_tag_data: any,
}

const Fetcher = async () => {
  const res: any = await GetInstaRepair();
  const page_details = page_data["insta-repair"]
  
  const data = {
    products: res?.data?.products || [],
    features: res?.data?.instarepair_data || {},
    faqs: page_details?.faqs || [],
    blogs: page_details?.blogs || [],
    cross_sell: page_details?.cross_sell || [],
    testimonials: page_details?.testimonials || [],
    bannerImageData: page_details?.banner_config || [],
    meta_tag_data: page_details?.meta_tag || [],
  
  }

  return data
}

export async function getServerSideProps() {
    const data = await Fetcher()
    return {
        props: { ...data, pageName: 'common-insta'}     
    }
}


export default function Home(props: Props) {
    const router = useRouter()
    const BASE_URL = Config.BASE_URL;
    const OG_IMAGE = getStaticPath(props.bannerImageData?.og_image)

    React.useEffect(()=>{
      trackPage("Insta Repair Home Page",{...getPageViewData()}) // GTM TRIGGER - track Page
    },[props])

    let cached_props:any = props || {}

    return (
        <Fragment>
            <Head>
                <title>{cached_props?.meta_tag_data?.tag_title}</title>
                <link rel="icon" href="/favicon.ico" />
                <meta name="description" content={cached_props?.meta_tag_data?.tag_description}></meta>
                <meta property="og:title" content={cached_props?.meta_tag_data?.tag_title}/>
                <meta property="og:description" content={cached_props?.meta_tag_data?.tag_description}/>
                <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
                <meta property="og:image" content={OG_IMAGE}/>
                <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
            </Head>
            <main>
                <BannerWithGraphic className={styles.instarepair} title={cached_props.bannerImageData.title} subtitle={cached_props.bannerImageData.subtitle} banner_img={cached_props.bannerImageData.image} isCommon={true} journeyType="Insta"/>
                <CategoryListCard list={cached_props.products} />
                <LazyLoader>
                <div className='odd-even-start-with-white'>
                  
                  <FeatureImageBanner title={cached_props.features.whatIsInstarepair !== undefined ? cached_props.features.whatIsInstarepair.title : ''} withSubtitle={false} features={cached_props.features.whatIsInstarepair !== undefined ? cached_props.features.whatIsInstarepair.features : ''} isGreyBackground={isMobile == true} mainSubtitle={cached_props.features.whatIsInstarepair? cached_props.features.whatIsInstarepair.subtitle: undefined} sectionClassName={featuresStyles.text_fix} className={`${featuresStyles.what_is_instarepair}`} isRoundShape={true} imageSizeClass={featuresStyles.amc__circle_image}/>
                  <FeatureImageBanner title={cached_props.features.whyChooseOnsitego !== undefined ? cached_props.features.whyChooseOnsitego.title : ''} withSubtitle={false} features={cached_props.features.whyChooseOnsitego !== undefined ? cached_props.features.whyChooseOnsitego.steps : ''} className={`${styles.grey__neutral}`} isGreyBackground={isMobile == false} />
                  <FeatureImageBanner title={cached_props.features && cached_props.features.stepsToProtect ? cached_props.features.stepsToProtect.title : ''} withSubtitle={false} features={cached_props.features !== undefined && !!cached_props.features.stepsToProtect ? cached_props.features.stepsToProtect.steps : ''} className={`${featuresStyles.grey}`} isGreyBackground={isMobile == true} sectionClassName={`font__dark no__bottom_padding`} isRoundShape={true} imageSizeClass={featuresStyles.amc__circle_image}  />
                  {cached_props.testimonials && cached_props.testimonials.length > 0 && <Testimonial testimonial={cached_props.testimonials} router={router}/>}
                  {cached_props.blogs && cached_props.blogs.length > 0 && <Blog key="wp-blog" blog={cached_props.blogs?cached_props.blogs:[]} title="Handpicked Blogs for you "/>}
                  {cached_props.faqs && cached_props.faqs.length !== 0 ? <Faq title="Frequently Asked Questions" questions={cached_props.faqs} className="faq-primary" /> : null}
                  {props.cross_sell.length !== 0 ? (<CrossSell list={props.cross_sell} router={router} />) : ''}

                </div>
                </LazyLoader>
            </main>
        </Fragment>
    )
}
